import '@fontsource/roboto/index.css';
import '@fontsource/roboto/500.css';
import '@fontsource/rubik/index.css';
import '@fontsource/rubik/500.css';
import '@fontsource/roboto-mono/index.css';
import '@fontsource/roboto-mono/500.css';

import React from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { TypographyComponent, TypographyProps } from './types';
import { variantMapping as cxnVariantMapping } from './mapping';

/* eslint-disable-next-line react/function-component-definition */
export const Typography: TypographyComponent = (props: TypographyProps) => {
  const {
    variant, variantMapping, strong, children, ...rest
  } = props;

  const mapping = Object.assign(cxnVariantMapping || {}, variantMapping);

  return (
    <MuiTypography
      fontWeight={strong ? '500 !important' : undefined}
      variant={variant}
      variantMapping={mapping}
      {...rest}
    >
      {children}
    </MuiTypography>
  );
};
